import * as React from "react"
import { useGoToSignInHome } from "src/frontend/components/Public/LogIn/Glow/useGoToSignInHome"
import { useResendMagicLink } from "src/frontend/components/Public/LogIn/Glow/useSendMagicLink"
import { useOnboardingContext } from "src/frontend/components/Public/Onboarding/OnboardingContext"
import { Email, EmailNotification } from "src/frontend/components/Shared/Glow/EmailNotification"

export const MagicLinkSent: React.FC = () => {
  const {
    state: { emailAddress },
  } = useOnboardingContext()
  const goHome = useGoToSignInHome()
  const { onMagicLinkClick, magicLinkLoading, disabled } = useResendMagicLink()

  return (
    <EmailNotification
      onBack={goHome}
      onClick={onMagicLinkClick}
      disabled={magicLinkLoading || disabled}
      title="Please check your email!"
    >
      If there is an account associated with <Email>{emailAddress}</Email>, you will receive an
      email with a link to sign in.
    </EmailNotification>
  )
}
